import styles from './NotBookableInfo.module.scss'
import { useTranslation } from 'next-i18next'
import travelAvailabilityStatusObject from '@/entities/travelAvailabilityStatus/interface'
import cmsContactBlockSettingsObject from '@/entities/cmsContactBlockSettings/interface'
import { Alert, Col, Container, Row } from 'react-bootstrap'
import ThemeImage from '@/components/elements/media/ThemeImage/ThemeImage'
import React from 'react'

interface Props {
  availabilityStatus: travelAvailabilityStatusObject
  contactBlockSettings: cmsContactBlockSettingsObject
}

const NotBookableInfo = ({ availabilityStatus, contactBlockSettings }: Props) => {
  const { t } = useTranslation('common')
  const { phonePrefix, phone, phone2Prefix, phone2, openingHours1, openingHours2, email } = contactBlockSettings
  const phoneLink = !phone ? phone : 'tel:' + phone.replace('(0)', '').split(' ').join('')
  const phone2Link = !phone2 ? phone2 : 'tel:' + phone2.replace('(0)', '').split(' ').join('')

  if (!availabilityStatus || !availabilityStatus.tenantSettings || availabilityStatus.status !== 'CLOSED') {
    return <></>
  }
  const tenantSettings = availabilityStatus.tenantSettings.find((tenantSettings) => {
    return tenantSettings.tenant.id === process.env.NEXT_PUBLIC_TENANT_ID
  })

  return (
    <Container className={styles.root}>
      <Row>
        <Col>
          <Alert>{tenantSettings && tenantSettings.info ? tenantSettings.info : t('booking.notBookableMessage')}</Alert>
        </Col>
      </Row>
      <Row className={styles.contactBlock}>
        <Col xs={'auto'} className={`${styles.icon} align-content-center`}>
          <ThemeImage src={'/images/mandatory/icons/contact/phone.png'} alt="icon" width={40} height={40} />
        </Col>
        <Col className={'d-flex align-items-center'}>
          <div>
            <div className={`${styles.link} mb-1`}>
              {phonePrefix && <span>{phonePrefix} </span>}
              <a href={phoneLink} data-tr-click="not_bookable_info:contact_phone:click">
                {phone}
              </a>
            </div>
            {phone2 && (
              <div className={`${styles.link} mb-1`}>
                {phone2Prefix && <span>{phone2Prefix} </span>}
                <a href={phone2Link} data-tr-click="not_bookable_info:contact_phone:click">
                  {phone2}
                </a>
              </div>
            )}
            <div className={styles.openingHours}>
              {openingHours1}
              {openingHours2 ? (
                <>
                  <br />
                  {openingHours2}
                </>
              ) : (
                ''
              )}
            </div>
          </div>
        </Col>
      </Row>
      <Row className={styles.contactBlock}>
        <Col xs={'auto'} className={styles.icon}>
          <ThemeImage src={'/images/mandatory/icons/contact/mail.png'} alt="icon" width={40} height={40} />
        </Col>
        <Col className={'d-flex align-items-center'}>
          <div className={styles.link}>
            <a href={'mailto:' + email} data-tr-click="not_bookable_info:contact_email:click">
              {email}
            </a>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default NotBookableInfo
